import React from 'react';
import BasicButton from './BasicButton';
import { lwtBlue, lwtDarkBlue } from '../../../styles/style-constants';
import { remCalc } from '../../../util/style-util';

type Props = {
  text: string;
  color: string;
  fill: string;
  buttonStyles: Array<any | false>;
  hoverFill: string;
  onClick?: (e: Event) => void;
};

const SquareButton = ({
  text,
  color,
  fill,
  hoverFill,
  buttonStyles,
  ...props
}: Props | any): JSX.Element => (
  <BasicButton
    color={color}
    fill={fill}
    hoverFill={hoverFill}
    text={text}
    buttonStyles={[{ borderRadius: '3px', padding: remCalc(12, 33) }, ...buttonStyles]}
    {...props}
  />
);

SquareButton.defaultProps = {
  color: 'white',
  fill: lwtBlue,
  buttonStyles: [],
  hoverFill: lwtDarkBlue
};

export default SquareButton;
